import { render, staticRenderFns } from "./TwLcDetailInner.vue?vue&type=template&id=424872c2&scoped=true&"
import script from "./TwLcDetailInner.vue?vue&type=script&lang=js&"
export * from "./TwLcDetailInner.vue?vue&type=script&lang=js&"
import style0 from "./TwLcDetailInner.vue?vue&type=style&index=0&id=424872c2&lang=scss&scoped=true&"
import style1 from "./TwLcDetailInner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424872c2",
  null
  
)

export default component.exports